/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import { Icon, Badge, Tabs, Button, List, message, notification, Tooltip } from 'antd';
import { getData } from '@util';
import {
  API_POST_MESSAGE_LIST,
  API_GET_WEBSOCKET_ADDR,
  API_PUT_TO_ALREADY_READ,
  API_PUT_TO_ALREADY_DEL,
} from '@api';
import './style/messageCenter.scss';
import { getVariant } from '@Variant';

const { TabPane } = Tabs;
// message.config({ prefixCls: 'csx-message' })

class MessageCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unReadList: [], //未读的消息列表
      alreadyReadList: [], //已读的消息列表
      key: '1', //tab索引
    };
    this.userId = null;
  }
  componentDidMount() {
    const { id = '' } = JSON.parse(getVariant('userInfos') || '{}'); //参数:当前用户的id
    this.userId = id;
    //获取websocket的 http
    getData({ api: API_GET_WEBSOCKET_ADDR }).then(res => {
      if (res && res.code === 200000) {
        const { data } = res;
        if (data) {
          this.initSocketObj(data);
          this.initSocketEvent(data);
        }
      }
    });
    //默认先加载一次,获取当前用户的所有xiaoxi列表
    this._getMessageList();
  }
  initSocketEvent = data => {
    //心跳检测对象
    const heartCheck = {
      timeOut: 5000, //每隔5秒发送心跳
      severTimeout: 10000, //服务端超时时间
      socket: this.socket, //这里拿到的永远是当前组件中的最新获取到的socket
      timeOutObj: null, //定时发送心跳包的定时器
      serverTimeoutObj: null, //检测超时时间的定时器
      clear: function (target) {
        clearTimeout(target);
      },
      start: function () {
        //清除上一个定时器
        const _this = this;
        this.timeoutObj && this.clear(this.timeoutObj);
        this.serverTimeoutObj && this.clear(this.serverTimeoutObj);
        this.timeOutObj = setTimeout(() => {
          //发送心跳包
          this.socket.send('ping');
          //计算答复时间
          _this.serverTimeoutObj = setTimeout(() => {
            this.socket.close();
          }, _this.severTimeout);
        }, this.timeOut);
      },
    };
    this.socket.onopen = () => {
      //this.isBreak && message.success('消息中心重新连接成功')
      //启动心跳包
      heartCheck.start();
    };
    this.socket.onmessage = msg => {
      const { data } = msg;
      //启动下一次心跳
      if (data === '连接成功') {
        return false;
      } else if (data === 'ping') {
        return heartCheck.start();
      }
      // else if(data === WS_HEART_STRING) {
      //   // 服务端来查岗, 啥也不干
      //   return
      // }
      else {
        this._getMessageList();
        setTimeout(() => {
          notification.info({
            prefixCls: 'csx-notification',
            message: '您有一条新消息',
            placement: 'bottomRight',
          });
        }, 0);
      }
    };
    this.socket.onclose = () => {
      this.reconnect(data);
    };
    this.socket.onerror = () => {
      this.reconnect(data);
    };
  };
  //连接websocket
  initSocketObj = url => {
    //socket需挂在this上,否则心跳检测会生成多个socket对象
    this.socket = new WebSocket(`ws://${url}/websocket/zt/${this.userId}`);
  };
  //重连
  reconnect = url => {
    //当一个重连正在执行的时候，禁止再触发一次重连
    if (this.lockReconnect) return;
    this.isBreak = true; //掉过线的标识
    this.lockReconnect = true;
    //message.loading('消息中心通信异常,尝试重新连接中...')
    setTimeout(() => {
      //没连接上会一直重连，设置延迟避免请求过多
      this.lockReconnect = false;
      this.initSocketObj(url);
      this.initSocketEvent(url);
    }, 5000);
  };
  //获取消息列表
  _getMessageList = () => {
    const data = {
      toUserId: this.userId,
      messageChannel: 'PC',
      delFlag: 0,
      pageNum: 1,
      pageSize: 500,
    };
    getData({ api: API_POST_MESSAGE_LIST, data }).then(res => {
      const { code, data } = res;
      if (data === null) {
        return this.setState({
          alreadyReadList: [],
          unReadList: [],
        });
      }
      if (data && code === 200000) {
        const unReadList = [];
        const alreadyReadList = [];
        data.data.map(item => {
          if (item.delFlag === 0) {
            if (item.status === 0) {
              unReadList.push(item);
            } else {
              alreadyReadList.push(item);
            }
          }
        });
        this.setState({
          alreadyReadList,
          unReadList,
        });
      }
    });
  };
  //渲染messageContent
  renderMessageContent = (message, withClass) => {
    const _message = message ? JSON.parse(message) : '';
    return _message ? (
      <div
        dangerouslySetInnerHTML={{ __html: _message.content }}
        className={withClass ? 'csx-MessageCenter-messageContentStyle ' : ''}></div>
    ) : null;
  };
  renderMessageTitle = title => {
    return (
      <div title={title}>
        【<span className="csx-MessageCenter-messageTitleStyle">{title}</span>】
      </div>
    );
  };
  renderItem = item => {
    const {
      id,
      messageTitle, //消息标题
      messageContent, //消息内容
      status, //已读和未读
    } = item;
    const btnProps = {
      className: 'csx-MessageCenter-btnStyle',
      size: 'small',
      onClick: status ? () => this.clearMessage(item) : () => this.putMessageToAlreadyRead(item),
    };
    const extra = status ? (
      <Button {...btnProps} loading={this.state[`${id}Loading`]}>
        清除
      </Button>
    ) : (
      <Button {...btnProps} loading={this.state[`${id}Loading`]}>
        标记已读
      </Button>
    );
    return (
      <Tooltip
        placement="left"
        trigger="hover"
        title={this.renderMessageContent(messageContent, false)}>
        <List.Item extra={extra}>
          <List.Item.Meta
            title={this.renderMessageTitle(messageTitle)}
            description={this.renderMessageContent(messageContent, true)}
          />
        </List.Item>
      </Tooltip>
    );
  };
  //消息标记已读
  putMessageToAlreadyRead = item => {
    const { id } = item;
    const data = [id];
    this.setState({ [`${id}Loading`]: true });
    getData({ api: API_PUT_TO_ALREADY_READ, data }).then(
      res => {
        if (res && res.code === 200000) {
          message.success(`${item.messageTitle}已标记为已读`);
          this._getMessageList();
          this.setState({ [`${id}Loading`]: false });
        }
      },
      err => {
        message.error(`${item.messageTitle}标记为已读失败,请重试`);
      },
    );
  };
  //单个清除消息按钮
  clearMessage = item => {
    const { id } = item;
    const data = [id];
    this.setState({ [`${id}Loading`]: true });
    getData({ api: API_PUT_TO_ALREADY_DEL, data }).then(
      res => {
        if (res && res.code === 200000) {
          message.success(`${item.messageTitle}已清除`);
          this._getMessageList();
          this.setState({ [`${id}Loading`]: false });
        }
      },
      err => {
        message.error(`${item.messageTitle}清除失败,请重试`);
      },
    );
  };
  //抽出来的公共方法,供handleClearMessage使用
  _batchDo = param => {
    const { api, list, successMsg, type, errorMsg } = param;
    if (!list.length) return message.error('暂无数据');
    const data = [];
    list.forEach(item => data.push(item.id));
    this.setState({ [`${type}Loading`]: true });
    getData({ api, data }).then(
      res => {
        if (res && res.code === 200000) {
          if (type === 'clearUnRead') {
            getData({
              api: API_PUT_TO_ALREADY_DEL,
              data,
            }).then(res => {
              this._getMessageList();
            });
          }
          message.success(successMsg);
          type !== 'clearUnRead' && this._getMessageList();
          this.setState({ [`${type}Loading`]: false });
        }
      },
      err => {
        message.error(errorMsg);
        this.setState({ [`${type}Loading`]: false });
      },
    );
  };
  //全部清除和标记已读按钮
  handleClearMessage = type => {
    const { unReadList, alreadyReadList } = this.state;
    if (type === 'turnAlreadyRead') {
      //标记已读 => 未读
      const param = {
        api: API_PUT_TO_ALREADY_READ,
        list: unReadList,
        type,
        successMsg: '您已标记所有未读消息为已读 !',
        errorMsg: '标记所有未读消息为已读失败,请重试 !',
      };
      this._batchDo(param);
    } else if (type === 'clearUnRead') {
      //清除未读的消息
      const param = {
        api: API_PUT_TO_ALREADY_READ,
        list: unReadList,
        type,
        successMsg: '您已清空所有未读消息 !',
        errorMsg: '清空所有未读消息失败,请重试 !',
      };
      this._batchDo(param);
    } else if (type === 'clearALRead') {
      //清除已读的消息
      const param = {
        api: API_PUT_TO_ALREADY_DEL,
        list: alreadyReadList,
        type,
        successMsg: '您已清空所有已读消息 !',
        errorMsg: '清空所有已读消息失败,请重试 !',
      };
      this._batchDo(param);
    }
  };
  render() {
    const {
      unReadList,
      alreadyReadList,
      key,
      turnAlreadyReadLoading,
      clearUnReadLoading,
      clearALReadLoading,
    } = this.state;
    const unReadNo = unReadList.length;
    const alReadNo = alreadyReadList.length;
    const badgeNo = unReadNo;
    return (
      <div className="csx-MessageCenter">
        <div className="csx-MessageCenter-iconWrapper" title="消息中心">
          <Badge count={badgeNo}>
            <Icon style={{ fontSize: 24 }} type="bell" />
          </Badge>
        </div>
        <div className="csx-MessageCenter-tabs">
          {/* 三角形  */}
          <div className="csx-MessageCenter-tri" />
          <Tabs defaultActiveKey="1" onChange={key => this.setState({ key })}>
            <TabPane tab={`未读(${unReadNo})`} key="1">
              <List dataSource={unReadList} renderItem={item => item && this.renderItem(item)} />
            </TabPane>
            <TabPane tab={`已读(${alReadNo})`} key="2">
              <List
                dataSource={alreadyReadList}
                renderItem={item => item && this.renderItem(item)}
              />
            </TabPane>
          </Tabs>
          {key === '1' ? (
            <div className="csx-MessageCenter-clearBtns">
              <Button
                onClick={this.handleClearMessage.bind(this, 'turnAlreadyRead')}
                loading={turnAlreadyReadLoading}>
                全部已读
              </Button>
              <Button
                onClick={this.handleClearMessage.bind(this, 'clearUnRead')}
                loading={clearUnReadLoading}>
                全部清除
              </Button>
            </div>
          ) : (
            <Button
              className="csx-MessageCenter-singleClearBtn"
              onClick={this.handleClearMessage.bind(this, 'clearALRead')}
              loading={clearALReadLoading}>
              全部清除
            </Button>
          )}
        </div>
      </div>
    );
  }
}
export default MessageCenter;
